export const metakeywords_model: any = {
    default: {
        metaKeywords: 'saldo, online, cambia saldo, saldoar, '
    },
    palpal: {
        metaKeywords:
            'saldo paypal argentina, saldoar, comprar dólares, comprar paypal, cambiar saldo paypal argentina, vender saldo paypal, compra y venta de saldo paypal, saldo paypal a mercadopago, saldo paypal gratis, comprar con saldo paypal, vender saldo paypal argentina'
    },
    skrill: {
        metaKeywords:
            'skrill a paypal, skrill, skrill argentina, skrill o neteller, skrill como funciona, skrill es seguro, skrill comisiones, skrill arca, skrill como funciona, pagar con skrill, páginas para pagar con skrill'
    },
    payoneer: {
        metaKeywords:
            'payoneer argentina, payoneer o paypal, payoneer es seguro, payoneer argentina arca 2022, payoneer, payoneer comisiones, payoneer fees, payoneer tarjeta, payoneer crear cuenta, payoneer vs wise, payoneer es confiable, transferwise como funciona, retirar saldo Payoneer, cambiar dólares de Payoneer, convertir saldo Payoneer, retirar dinero de Payoneer, cambiar Payoneer con bajas comisiones, convertir Payoneer, mejores formas de convertir saldo Payoneer, paso a paso para retirar saldo de Payoneer, mejor plataforma para convertir Payoneer, cambiar dólares Payoneer a moneda local, retiro de Payoneer a cuenta bancaria'
    },
    wise: {
        metaKeywords:
            'wise argentina, wise, wise que es, wise app, transferwise, venta de saldo wise, retirar dinero de wise, wise a uphold, vender saldo wise argentina, de wise a crypto'
    },
    payeer: {
        metaKeywords:
            'payeer to paypal, payeer limites, payeer es seguro, payeer fees, payeer comisiones, payeer wallet, payeer que es, payeer criptomonedas, payeer como funciona, payeer es confiable, payeer paypal, payeer app'
    },
    neteller: {
        metaKeywords:
            'neteller, neteller o skrill, neteller paypal, neteller comisiones, neteller es confiable, transferencias neteller, neteller argentina, neteller que es, neteller a mercadopago, neteller retirar dinero, neteller confiable'
    },
    zelle: {
        metaKeywords:
            'zelle, zelle que es, zelle app, zelle registro, zelle argentina, zelle en venezuela, zelle como funciona, usar zelle, que es zelle, como recibir dinero por zelle, enviar dinero por zelle, abrir una cuenta zelle'
    },
    pago_movil: {
        metaKeywords: ' pago movil venezuela, pago movil movistar, pago express, pago movil, pago movil colombia, pago movil mercantil'
    },
    banco: {
        metaKeywords:
            'transferencias bancarias 2022 argentina, hacer transferencia bancaria por home banking, justificar transferencia bancaria, transferir dinero a un cbu, transferencia bancaria por cajero, transferencia bancaria bbva, transferencia bancaria santander'
    },
    uphold: {
        metaKeywords:
            'advcash en español, advcash wallet, advcash binance, advcash app, advcash argentina, advcash opiniones, advcash crear cuenta'
    },
    advcash: {
        metaKeywords:
            'uphold es seguro, uphold a binance, uphold argentina, uphold wallet, uphold, uphold que es y como funciona, uphold registrarse, aplicacion uphold, retirar dinero de advcash, dinero advcash'
    },
    perfectmoney: {
        metaKeywords:
            'sacar dinero perfect money, como funciona perfect money, perfect money app, perfect money argentina, perfect money como funciona, perfect money login, perfect money paypal, perfect money fees'
    }
};
